import React, { memo } from "react";
import Container from "../components/Container";

const Contactus = memo(() => {
  return (
    <Container>
      <div id="Contactus" className=" text-xl py-6">
        If you have any issues, questions or suggestions please contact us via{" "}
        <span className=" font-bold">justsavevideo(at)gmail.com</span>
      </div>
    </Container>
  );
});

export default Contactus;
